import Vue from 'vue'
import Router from 'vue-router'

//for transaction forms
const transaction = require('../config.js').configs.transactionTypes;

let businessId = null;

//if(process.env.NODE_ENV === 'development'){
//   var LocalApi = require('../device').DeviceApi;
//   Vue.prototype.business = LocalApi.getBusiness();
//   businessId = Vue.prototype.business.businessId;
//   console.log(Vue.prototype.business);
//}

if(typeof DeviceApi !== "undefined" && DeviceApi !== null){
  Vue.prototype.business = JSON.parse(DeviceApi.getBusiness());
  businessId = Vue.prototype.business.businessId;
//   console.log(Vue.prototype.business);
}
// else{
//   console.log('device api not defined');
// }

// import reports from '@/components/reports'

import reportTileView from '@/components/newreports/report_templates/tileview'
// import reportList from '@/components/reports_list_uat'


// const reportscontainer = () => import('@/components/reportscontainer');
// const generalreport = () => import('@/components/reports/generalreport');
// const unauthorize = () => import('@/components/error');
// const transtemplate = () => import('@/components/transprint/template');
// const printtemplates = () => import('@/components/transprint/printtemplates');
// const test = () => import('@/components/testlanding');


//testing perpose
// const reportscontainerdev = () => import('@/components/reportscontainer_dev');
// const generalreportdev = () => import('@/components/businessReports/generalreport');

// import testpage from '@/components/test'

// import dashboard from '@/components/dashboard/dashboard'

import dashboardtabs from  '@/components/newreports/dashboard/tabs'

import activitytabs from  '@/components/activity/tabs'

import actions from  '@/components/actions/actions'

import accountantLanding from  '@/components/accountant/accountant_landing'

import notifications from  '@/components/notification/notifications'
import notificationDetail from  '@/components/notification/notification_detail'

import settings from  '@/components/settings/settings'
import userFeedbackForm from '@/components/settings/feedback/form'
import developerOptions from  '@/components/settings/developer_options'
import copytoken from  '@/components/settings/copy_token'
import tempview from  '@/components/settings/tempview'
import apitest from  '@/components/settings/apitest'
import apibaseurl from  '@/components/settings/apibaseurl'
import configurations from  '@/components/settings/configurations/configurations'
import businessSettings from  '@/components/settings/business/business_settings'
import accountantProfileSettings from  '@/components/settings/business/accountant_profile_settings'
// import myBusiness from  '@/components/settings/business/my_business'
import businessList from  '@/components/settings/business/business_list'

import instaSync from  '@/components/settings/instasync'
import instaSyncDocuments from  '@/components/settings/instasync_documents'
import connections from  '@/components/settings/connections'
import connectionDetails from  '@/components/settings/connection_details'
import appUpdate from  '@/components/settings/appupdate'
import join from  '@/components/settings/join'

import about from  '@/components/settings/about/about'
import openSourceLibs from  '@/components/settings/about/contents/open_source_libs'

import upiForm from  '@/components/settings/payment/form_upi'
import upiDisplay from  '@/components/settings/payment/display_upi'

import accountantItems from  '@/components/settings/accountant/items'
import accountantForm from  '@/components/settings/accountant/form'

import connectionRequestItems from  '@/components/settings/connection_requests/items'
import serviceTimer from  '@/components/settings/connection_requests/service_timer'

import transactionTypeSettings from  '@/components/settings/transaction/transaction_type_settings'
import transactionTypeItems from  '@/components/settings/transaction/transaction_type_items'
import transactionTypeForm from  '@/components/settings/transaction/transaction_type_form'
import transactionTypeFormCopy from  '@/components/settings/transaction/transaction_type_form_copy'

// import transactionSettings from  '@/components/settings/transaction_settings/transaction_settings'
import transactionSettingsNew from  '@/components/settings/transaction_settings/transaction_settings_new'

import thermalPrintSettings from  '@/components/settings/print_settings/thermal_print'

import labelPrintSettings from  '@/components/settings/print_settings/label_print'

import utilities from  '@/components/settings/utilities/utilities'

// import accountGroups from  '@/components/settings/account_groups/items'
import accountGroupSettingForm from  '@/components/settings/account_groups/form'

import securityOptions from  '@/components/settings/security/security_options'
import dataShareOptions from  '@/components/settings/datashare/toggle_data_share'
import openingDate from  '@/components/settings/opening_date/opening_date'

// import supportList from  '@/components/settings/support/support_list'
// import uploadDatabase from  '@/components/settings/support/upload_database'
// import cloneBusiness from  '@/components/settings/support/clone_business'

import backupData from  '@/components/settings/backup_data/backup'
import backupDataList from  '@/components/settings/backup_data/databackup_list'
import clearData from  '@/components/settings/backup_data/clear_data'

import temporaryBusinesses from  '@/components/settings/temporary_businesses/items'

import businessLogo from  '@/components/settings/business_logo/logo'

import sendInvitation from  '@/components/settings/send_invitation'

import bluetoothDevices from  '@/components/settings/bluetooth/devices'
import usbDevices from  '@/components/settings/bluetooth/usb_devices'


// drafts
// import drafts from  '@/components/actions/draft/drafts'
import drafts from  '@/components/actions/draft/drafts'

// masters
import unitsform from '@/components/masters/forms/units/form';
import unitsdisplay from '@/components/masters/forms/units/display';
import unitsitems from '@/components/masters/forms/units/items';

import discountsform from '@/components/masters/forms/discounts/form';
import discountsdisplay from '@/components/masters/forms/discounts/display';
import discountsitems from '@/components/masters/forms/discounts/items';

import taxesform from '@/components/masters/forms/taxes/form';
import taxesdisplay from '@/components/masters/forms/taxes/display';
import taxesitems from '@/components/masters/forms/taxes/items';

import otherchargesform from '@/components/masters/forms/other_charges/form';
import otherchargesdisplay from '@/components/masters/forms/other_charges/display';
import otherchargesitems from '@/components/masters/forms/other_charges/items';

import listsform from '@/components/masters/forms/lists/form';
import listsitems from '@/components/masters/forms/lists/items';
import listsdisplay from '@/components/masters/forms/lists/display';

import listitemform from '@/components/masters/forms/lists/list_items/form';
import listitemdisplay from '@/components/masters/forms/lists/list_items/display';
import listitemitems from '@/components/masters/forms/lists/list_items/items';

import accountgroupform from '@/components/masters/forms/account_groups/form';
import accountgroupdisplay from '@/components/masters/forms/account_groups/display';
import accountgroupitems from '@/components/masters/forms/account_groups/items';

import expensecategoryform from '@/components/masters/forms/expense_categories/form';
import expensecategorydisplay from '@/components/masters/forms/expense_categories/display';
import expensecategoryitems from '@/components/masters/forms/expense_categories/items';

import productcategoryform from '@/components/masters/forms/product_categories/form';
import productcategorydisplay from '@/components/masters/forms/product_categories/display';
import productcategoryitems from '@/components/masters/forms/product_categories/items';

import productserviceform from '@/components/masters/forms/product/form';
import productservicedisplay from '@/components/masters/forms/product/display';
import productserviceitems from '@/components/masters/forms/product/items';
import itemsImport from '@/components/masters/forms/product/items_import'
import productBatches from '@/components/transactions/forms/product_batches/batches'

import ledgerform from '@/components/masters/forms/ledgers/form';
import ledgerdisplay from '@/components/masters/forms/ledgers/display';
import ledgeritems from '@/components/masters/forms/ledgers/items';
import ledgeritemsweb from '@/components/masters/forms/ledgers/items_web';
import statementview from '@/components/masters/forms/ledgers/ledger_statement_view';
import ledgersImport from '@/components/masters/forms/ledgers/ledgers_import'

// import statement from '@/components/masters/forms/ledgers/ledger_statement2';

// import currencyform from '@/components/masters/forms/currency/form';
// import currencydisplay from '@/components/masters/forms/currency/display';
// import currencyitems from '@/components/masters/forms/currency/items';

import fieldform from '@/components/fields/form';
import fielddisplay from '@/components/fields/display';
import fielditems from '@/components/fields/items';

import taxcategoryform from '@/components/masters/forms/tax_category/form';
import taxcategorydisplay from '@/components/masters/forms/tax_category/display';
import taxcategoryitems from '@/components/masters/forms/tax_category/items';

import godownform from '@/components/masters/forms/godowns/form';
import godowndisplay from '@/components/masters/forms/godowns/display';
import godownitems from '@/components/masters/forms/godowns/items';

// import placeholder from '@/components/masters/placeholder';

// import testview from '@/components/testview';

// import masteractivitylist from '@/components/masters/activitylist';

// transaction
import purchaseForm from '@/components/transactions/forms/purchase/form';
import purchaseItems from '@/components/transactions/forms/purchase/items';
import purchaseDisplay from '@/components/transactions/forms/purchase/display';

import expenseForm from '@/components/transactions/forms/expense/form';
import expenseItems from '@/components/transactions/forms/expense/items';
import expenseDisplay from '@/components/transactions/forms/expense/display';

import salesForm from '@/components/transactions/forms/sale/form';
import salesItems from '@/components/transactions/forms/sale/items';
import salesDisplay from '@/components/transactions/forms/sale/display';

import accountBookForm from '@/components/transactions/forms/accountbooks/form';
import accountBookItems from '@/components/transactions/forms/accountbooks/items';
import accountBookDisplay from '@/components/transactions/forms/accountbooks/display';

import partyBalanceForm from '@/components/transactions/forms/party_balance/form';
import partyBalanceDisplay from '@/components/transactions/forms/party_balance/display';

import openingStockForm from '@/components/transactions/forms/opening_stock/form';
import openingStockDisplay from '@/components/transactions/forms/opening_stock/display';
import openingStockItems from '@/components/transactions/forms/opening_stock/items';

import stockJournalForm from '@/components/transactions/forms/stock_journal/form';
import stockJournalDisplay from '@/components/transactions/forms/stock_journal/display';
import stockJournalItems from '@/components/transactions/forms/stock_journal/items';

import stockAdjustmentForm from '@/components/transactions/forms/stock_adjustment/form';
import stockAdjustmentDisplay from '@/components/transactions/forms/stock_adjustment/display';

import stockTransferForm from '@/components/transactions/forms/stock_transfer/form';
import stockTransferDisplay from '@/components/transactions/forms/stock_transfer/display';
import stockTransferItems from '@/components/transactions/forms/stock_transfer/items';

import bomProductionForm from '@/components/transactions/forms/bom_production/form';
import bomProductionDisplay from '@/components/transactions/forms/bom_production/display';
import bomProductionItems from '@/components/transactions/forms/bom_production/items';

import openingLedgerForm from '@/components/transactions/forms/opening_ledger/form';
import openingLedgerDisplay from '@/components/transactions/forms/opening_ledger/display';
import openingLedgerItems from '@/components/transactions/forms/opening_ledger/items';

import creditDebitNote from '@/components/transactions/forms/credit_debit_note/form';

import numberSeriesForm from '@/components/number_series/form2';
import numberSeriesItems from '@/components/number_series/items';

import printTemplateForm from '@/components/print_templates/form';
import printTemplateItems from '@/components/print_templates/items';

import printFieldForm from '@/components/print_fields/form';
import printFieldItems from '@/components/print_fields/items';

import barcodeScanner from '@/components/barcode/scanner';

import barcodeGenerator from '@/components/barcode/barcode_generator';
import barcodeLabelConfig from '@/components/barcode/barcode_label_config';

import barcodeDesigner from '@/components/barcode/barcode_designer';
import barcodeLabelTemplates from '@/components/barcode/items';
// import priceListForm from '@/components/pricelist/form';
// import priceListDisplay from '@/components/pricelist/display';
// import priceListItems from '@/components/pricelist/items';

import languageSelection from '@/components/settings/language/language_selection';

// import userSettings from '@/components/settings/user_settings/items';

// import userForm from '@/components/settings/user_settings/users/form';
// import userItems from '@/components/settings/user_settings/users/items';

// import designationForm from '@/components/settings/user_settings/designations/form';
// import designationItems from '@/components/settings/user_settings/designations/items';

// import permissionGroupForm from '@/components/settings/user_settings/permission_groups/form';
// import permissionGroupItems from '@/components/settings/user_settings/permission_groups/items';


// import loginForm from '@/components/registration/login'
// import activateBusiness from '@/components/registration/activate_business'
// import signupForm from '@/components/registration/signup'
// import newBusiness from '@/components/registration/add_business'
import updateBusiness from '@/components/registration/update_business'
import businessDetails from '@/components/registration/business_details'
import otpVerification from '@/components/registration/otp_verification'
import setupDrive from '@/components/registration/set_backup_drive'
// import selectBusiness from '@/components/registration/business_selection_list'
// import restoreData from '@/components/registration/restore_data'
import changePhoneNumber from '@/components/registration/change_phone_number'

import userType from '@/components/registration/user_type'

import ledgerReport from '@/components/settings/ledgerreport'


//new reports
// import reportList from '@/components/newreports/reportlist'
import reportContainer from '@/components/newreports/report_container'

// import billtemplate from '@/components/bill_templates/template1'
// import billtemplate2 from '@/components/bill_templates/template2'
// import billtemplate3 from '@/components/bill_templates/template3'
// import billtemplate4 from '@/components/bill_templates/template_accountbook'
// import billtemplate5 from '@/components/invoice_templates/stockjournal_print'

// import temp1 from '@/components/bill_templates/template4'
// import temp2 from '@/components/bill_templates/template5'
// import temp3 from '@/components/bill_templates/template6'
// import temp4 from '@/components/bill_templates/template7'
// import temp5 from '@/components/bill_templates/template8'

import invoicePreview from '@/components/invoice_templates/invoice_preview'
import invoicePreviewSettings from '@/components/invoice_templates/invoice_template_preview'
// import printSettings from '@/components/settings/print_settings'

import pwaTest from '@/components/pwa_test'

Vue.use(Router);

export default new Router({
    // base:'/version20/',
  routes: [

    { path: '/', redirect: '/actions'},
    // { path: '/', redirect: '/pwatest'},
    { path: '/pwatest', component:pwaTest, name:"pwaTest"},

    // { path: '/billtemplate', component:billtemplate, name:'billtemplate'},
    // { path: '/billtemplate2', component:billtemplate2, name:'billtemplate2'},
    // { path: '/billtemplate3', component:billtemplate3, name:'billtemplate3'},
    // { path: '/billtemplate4', component:billtemplate4, name:'billtemplate4'}, 
    // { path: '/billtemplate5', component:billtemplate5, name:'billtemplate5'}, 
    // { path: '/printsettings', component:printSettings, name:'printsettings'},

    // { path: '/temp1', component:temp1, name:'temp1'}, 
    // { path: '/temp2', component:temp2, name:'temp2'}, 
    // { path: '/temp3', component:temp3, name:'temp3'}, 
    // { path: '/temp4', component:temp4, name:'temp4'}, 
    // { path: '/temp5', component:temp5, name:'temp5'}, 

    { path: '/invoice/preview', component:invoicePreview, name:'invoicePreview'},
    { path: '/invoice/preview/settings', component:invoicePreviewSettings, name:'invoicePreviewSettings'},

    // { path: '/testtileview', component:reportTileView, name:"reportTileView"},
    // { path: '/testpage', component:testpage, name:"testpage"},


  //Dashboard Tabs
    { path: '/dashboard', component:dashboardtabs, name:"reports"},

  //Activity Tabs
    { path: '/Activity', component:activitytabs, name:"activitytabs"},

  //Notifications
    { path: '/Notifications', component:notifications, name:"notifications"},
    { path: '/notifications/:businessid/:notificationid', component:notificationDetail, name:"notificationDetail"},
  
  //Notifications
    { path: '/product/batches', component:productBatches, name:"productBatches"},

  //Settings
    { path: '/settings', component:settings, name:"settings"},
    { path: '/settings/token', component:copytoken, name:"copytoken"},
    { path: '/settings/tempview', component:tempview, name:"tempview"},
    { path: '/settings/developeroptions', component:developerOptions, name:"developerOptions"},
    { path: '/settings/apibaseurl', component:apibaseurl, name:"apibaseurl"},
    { path: '/settings/configurations', component:configurations, name:"configurations"},
    { path: '/settings/business', component:businessSettings, name:"businessSettings"},
    { path: '/settings/business/items', component:businessList, name:"businessList"},
    { path: '/settings/accountant/profile', component:accountantProfileSettings, name:"accountantProfileSettings"},
    { path: '/settings/openingdate', component:openingDate, name:"openingDate"},
    { path: '/settings/feeback/:rating', component:userFeedbackForm, name:"userFeedbackForm"},
    { path: '/settings/apitest', component:apitest, name:"apitest"},
    // { path: '/settings/business/mybusiness', component:myBusiness, name:"myBusiness"},

    { path: '/settings/transaction', component:transactionTypeSettings, name:"transactionTypeSettings"},
    { path: '/settings/transaction/:typeId', component:transactionTypeItems, name:"transactionTypeItems"},
    { path: '/settings/transaction/:typeId/new', component:transactionTypeForm, name:"transactionTypeForm"},
    // { path: '/settings/transaction/:typeId/:tagId', component:transactionTypeForm, name:"transactionTypeEditForm"},
    { path: '/settings/transaction/:typeId/:tagId', component:transactionTypeFormCopy, name:"transactionTypeEditForm"},

    // { path: '/settings/business/transaction', component:transactionSettings, name:"transactionSettings"},
    { path: '/settings/business/transactionnew', component:transactionSettingsNew, name:"transactionSettingsNew"},

    { path: '/settings/business/thermalprintsettings', component:thermalPrintSettings, name:"thermalPrintSettings"},

    { path: '/settings/business/labelprintsettings', component:labelPrintSettings, name:"labelPrintSettings"},

    { path: '/settings/utilities', component:utilities, name:"utilities"},

    // { path: '/settings/accountgroup', component:accountGroups, name:"accountGroups"},
    { path: '/settings/accountgroup', component:accountGroupSettingForm, name:"accountGroupSettingForm"},

    { path: '/settings/security', component:securityOptions, name:"securityOptions"},

    { path: '/settings/datashare', component:dataShareOptions, name:"dataShareOptions"},

    // { path: '/settings/support', component:supportList, name:"supportList"},
    // { path: '/settings/support/upload_database', component:uploadDatabase, name:"uploadDatabase"},
    // { path: '/settings/support/clone_business', component:cloneBusiness, name:"cloneBusiness"},

    { path: '/settings/backup', component:backupData, name:"backupData"},
    { path: '/settings/backup/items', component:backupDataList, name:"backupDataList"},
    { path: '/settings/cleardata', component:clearData, name:"clearData"},
    { path: '/settings/logo/upload', component:businessLogo, name:"businessLogo"},

    { path: '/settings/temporary_businesses', component:temporaryBusinesses, name:"temporaryBusinesses"},

    { path: '/settings/about', component:about, name:"about"},
    { path: '/settings/about/libraries', component:openSourceLibs, name:"libraries"},

    { path: '/settings/instasync', component:instaSync, name:"instasync"},
    { path: '/settings/documentsync', component:instaSyncDocuments, name:"instasyncdocuments"},
    { path: '/settings/connections', component:connections, name:"connections"},
    { path: '/settings/connectiondetails', component:connectionDetails, name:"connectionDetails"},
    { path: '/settings/appupdate', component:appUpdate, name:"appUpdate"},
    { path: '/settings/join', component:join, name:"join"},

    { path: '/settings/sendinvitation', component:sendInvitation, name:"sendInvitation"},

    { path: '/settings/payment/upi/new', component:upiForm, name:"upiForm"},
    { path: '/settings/payment/upi/display', component:upiDisplay, name:"upiDisplay"},

    { path: '/settings/accountant/items', component:accountantItems, name:"accountantItems"},
    { path: '/settings/accountant/items/new', component:accountantForm, name:"accountantForm"},

    { path: '/settings/connectionrequest/items', component:connectionRequestItems, name:"connectionRequestItems"},
    { path: '/settings/connectionrequest/servicetimer', component:serviceTimer, name:"serviceTimer"},
  
    { path: '/settings/bluetoothdevices', component:bluetoothDevices, name:"bluetoothDevices"},
    { path: '/settings/usbdevices', component:usbDevices, name:"usbDevices"},
  //Actions
    { path: '/actions', component:actions, name:"actions"},

    { path: '/accountant', component:accountantLanding, name:"accountantLanding"},

  //Drafts
    // { path: '/drafts', component: drafts, name:"drafts"},

    { path: '/drafts', component: drafts, name:"drafts"},

  	// { path: '*', component: unauthorize },

    // { path: '/placeholder', component:placeholder},
    // { path: '/testview/:id', component: testview},

    // { path: '/:dialogs', component: test},

    //Reports routing
    // { path: '/:businessid/reports', component:reports, name:"reports"},
    // { path: '/:businessid/reports', component:reportList, name:"reports"},

  //   { path: '/reportscontainer', component:reportscontainer, 
  // 		children: [
		// 	{path:'/:businessid/reports/:reportid', component:generalreport}
		// ]
  //   },

     //Reports test routing
    // { path: '/reports', component:reports, name:"reports"},

    // { path: '/reportstest', component:reportscontainerdev, 
    //     children: [
    //         {path:'/report_uat/:reportId', component:generalreportdev}
    //     ]
    // },


    //Transaction Routing    
    // { path: '/unauthorize', component:unauthorize},
    // { path: '/transactions/:transactionID/print', component:transtemplate},
    // { path: '/transactions/printtemplates', component:printtemplates},

    // { path: '/dashboard', component:dashboard, name:"dashboard"},


    //Forms routing
    
    //Units
    { path: '/inventory/units/items', name:'unitItems', component:unitsitems, props:true},
    { path: '/inventory/units/new', name:'newUnit', component:unitsform},
    { path: '/inventory/units/:tagId', name:'unitDisplay', component:unitsdisplay},
    { path: '/inventory/units/:tagId/edit', name:'unitEdit', component:unitsform},
    // { path: '/inventory/units/new/:dialogs', component:unitsform},

    //Discounts
    { path: '/addons/discounts/items', name:'discountItems', component:discountsitems, props:true},
    { path: '/addons/discounts/new', name:'newDiscount', component:discountsform},
    { path: '/addons/discounts/:tagId', name:'discountDisplay', component:discountsdisplay},
    { path: '/addons/discounts/:tagId/edit', name:'discountEdit', component:discountsform},

    //Taxes
    { path: '/addons/taxes/items', name:'taxesItems', component:taxesitems, props:true},
    { path: '/addons/taxes/new', name:'newTaxes', component:taxesform},
    { path: '/addons/taxes/:tagId', name:'taxesDisplay', component:taxesdisplay},
    { path: '/addons/taxes/:tagId/edit', name:'taxesEdit', component:taxesform},

    // Other Charges
    { path: '/addons/othercharges/items', name:'otherChargesItems', component:otherchargesitems, props:true},
    { path: '/addons/othercharges/new', name:'newOtherCharges', component:otherchargesform},
    { path: '/addons/othercharges/:tagId', name:'otherChargesDisplay', component:otherchargesdisplay},
    { path: '/addons/othercharges/:tagId/edit', name:'otherChargesEdit', component:otherchargesform},

    //Lists
    { path: '/masters/lists/items', name:'listsItems', component:listsitems, props:true},
    { path: '/masters/lists/new', name:'newList', component:listsform},
    { path: '/masters/lists/:tagId', name:'listDisplay', component:listsdisplay},
    { path: '/masters/lists/:tagId/edit', name:'listEdit', component:listsform},
    // { path: '/masters/lists/items', component:listsform},

    //List Items
    { path: '/masters/lists/:listId/items', name:'listsItemItems', component:listitemitems},
    { path: '/masters/lists/:listId/items/new', name:'newListItem', component:listitemform},
    { path: '/masters/lists/:listId/items/:tagId', name:'listItemDisplay', component:listitemdisplay},
    { path: '/masters/lists/:listId/items/:tagId/edit', name:'listItemEdit', component:listitemform},

    //Account Groups
    { path: '/masters/accounts/groups/items', name:'accountsGroupItems', component:accountgroupitems, props:true},
    { path: '/masters/accounts/groups/new', name:'newAccountGroup', component:accountgroupform},
    { path: '/masters/accounts/groups/:tagId', name:'accountGroupDisplay', component:accountgroupdisplay},
    { path: '/masters/accounts/groups/:tagId/edit', name:'accountGroupEdit', component:accountgroupform},

    //Expense Categories
    { path: '/masters/expensecategory/items', name:'expenseCategoryItems', component:expensecategoryitems, props:true},
    { path: '/masters/expensecategory/items/new', name:'newexpenseCategory', component:expensecategoryform},
    { path: '/masters/expensecategory/items/:tagId', name:'expenseCategoryDisplay', component:expensecategorydisplay},
    { path: '/masters/expensecategory/items/:tagId/edit', name:'expenseCategoryEdit', component:expensecategoryform},

    //Product/Service Categories
    { path: '/masters/inventory/product/categories/items', name:'productCategoriesItems', component:productcategoryitems, props:true},
    { path: '/masters/inventory/product/categories/new', name:'newProductCategories', component:productcategoryform},
    { path: '/masters/inventory/product/categories/:tagId', name:'productCategoriesDisplay', component:productcategorydisplay},
    { path: '/masters/inventory/product/categories/:tagId/edit', name:'productCategoriesEdit', component:productcategoryform},
    

    //Products/Services
    { path: '/masters/inventory/productandservices/items', name:'productAndServiceItems', component:productserviceitems, props:true},
    { path: '/masters/inventory/productandservices/items/new', name:'newProduct', component:productserviceform},
    { path: '/masters/inventory/productandservices/items/import', name:'itemsImport', component:itemsImport},
    { path: '/masters/inventory/productandservices/items/:tagId', name:'productDisplay', component:productservicedisplay},
    { path: '/masters/inventory/productandservices/items/:tagId/edit', name:'productEdit', component:productserviceform},


    //Ledgers
    // { path: '/masters/accounts/ledgers/items/list', name:'ledgerItems', component:ledgeritems, props:true},
    { path: '/masters/accounts/ledgers/items', name:'ledgerItems', component:ledgeritems, props:true},
    { path: '/masters/accounts/ledgers/items_web', name:'ledgerItemsWeb', component:ledgeritemsweb, props:true},
    { path: '/masters/accounts/ledgers/items/new', name:'newLedger', component:ledgerform},
    { path: '/masters/accounts/ledgers/items/import', name:'ledgersImport', component:ledgersImport},
    { path: '/masters/accounts/ledgers/items/:tagId', name:'ledgerDisplay', component:ledgerdisplay},
    { path: '/masters/accounts/ledgers/items/:tagId/edit', name:'ledgerEdit', component:ledgerform},
    { path: '/masters/accounts/ledgers/items/:tagId/statement', name:'statementView', component:statementview},
    // { path: '/statement', name:'statement', component:statement},

    //currency
    // { path: '/masters/currency/items', name:'currencyItems', component:currencyitems, props:true},
    // { path: '/masters/currency/items/new', name:'newCurrency', component:currencyform},
    // { path: '/masters/currency/items/:tagId', name:'ledgerCurrency', component:currencydisplay},
    // { path: '/masters/currency/items/:tagId/edit', name:'currencyEdit', component:currencyform},

    { path: '/fields/items', name:'fieldItems', component:fielditems, props:true},
    { path: '/fields/new', name:'newField', component:fieldform},
    { path: '/fields/:tagId', name:'fieldDisplay', component:fielddisplay},
    { path: '/fields/:tagId/edit', name:'fieldEdit', component:fieldform},

    { path: '/tax/category/items', name:'taxCategoryItems', component:taxcategoryitems, props:true},
    { path: '/tax/category/items/new', name:'newTaxCategory', component:taxcategoryform},
    { path: '/tax/category/items/:tagId', name:'taxCategoryDisplay', component:taxcategorydisplay},
    { path: '/tax/category/items/:tagId/edit', name:'taxCategoryEdit', component:taxcategoryform},

    { path: '/masters/inventory/godown/items', name:'godownItems', component:godownitems, props:true},
    { path: '/masters/inventory/godown/items/new', name:'newGodown', component:godownform},
    { path: '/masters/inventory/godown/items/:tagId', name:'godownDisplay', component:godowndisplay},
    { path: '/masters/inventory/godown/items/:tagId/edit', name:'godownEdit', component:godownform},

    // { path: '/masters/placeholder', component:placeholder, name:'placeholder'},

    /*====================================================== Transactions ======================================================*/

    //Receipt
    { path: '/transactions/receipt/items', name:'receiptItems', component:accountBookItems, props: {settings:{transactionTypeId:transaction.receipt.id}}},
    { path: '/transactions/receipt/items/new', name:'newReceipt', component:accountBookForm, props: {settings:{transactionTypeId:transaction.receipt.id}}},
    { path: '/transactions/receipt/items/:tagId', name:'receiptDisplay', component:accountBookDisplay, props: {settings:{transactionTypeId:transaction.receipt.id}}},
    { path: '/transactions/receipt/items/:tagId/edit', name:'receiptEdit', component:accountBookForm, props: {settings:{transactionTypeId:transaction.receipt.id}}},

    //Payment
    { path: '/transactions/payment/items', name:'paymentItems', component:accountBookItems, props: {settings:{transactionTypeId:transaction.payment.id}}},
    { path: '/transactions/payment/items/new', name:'newPayment', component:accountBookForm, props: {settings:{transactionTypeId:transaction.payment.id}}},
    { path: '/transactions/payment/items/:tagId', name:'paymentDisplay', component:accountBookDisplay, props: {settings:{transactionTypeId:transaction.payment.id}}},
    { path: '/transactions/payment/items/:tagId/edit', name:'paymentEdit', component:accountBookForm, props: {settings:{transactionTypeId:transaction.payment.id}}},

    //Journal
    { path: '/transactions/journal/items', name:'journalItems', component:accountBookItems, props: {settings:{transactionTypeId:transaction.journal.id}}},
    { path: '/transactions/journal/items/new', name:'newJournal', component:accountBookForm, props: {settings:{transactionTypeId:transaction.journal.id}}},
    { path: '/transactions/journal/items/:tagId', name:'journalDisplay', component:accountBookDisplay, props: {settings:{transactionTypeId:transaction.journal.id}}},
    { path: '/transactions/journal/items/:tagId/edit', name:'journalEdit', component:accountBookForm, props: {settings:{transactionTypeId:transaction.journal.id}}},

    //Set Balance Journal Handling
    { path: '/transactions/setbalance/items/new', name:'setPartyBalance', component:partyBalanceForm, props: {settings:{transactionTypeId:transaction.partyBalance.id}}},
    { path: '/transactions/setbalance/items/:tagId', name:'partyBalanceDisplay', component:partyBalanceDisplay, props: {settings:{transactionTypeId:transaction.partyBalance.id}}},

    // Contra
    { path: '/transactions/contra/items', name:'contraItems', component:accountBookItems, props: {settings:{transactionTypeId:transaction.contra.id}}},
    { path: '/transactions/contra/items/new', component:accountBookForm, name:'newContra', props: {settings:{transactionTypeId:transaction.contra.id}}},
    { path: '/transactions/contra/items/:tagId', name:'contraDisplay', component:accountBookDisplay, props: {settings:{transactionTypeId:transaction.contra.id}}},
    { path: '/transactions/contra/items/:tagId/edit', name:'contraEdit', component:accountBookForm, props: {settings:{transactionTypeId:transaction.contra.id}}},

    // //Credit Note
    // { path: '/transactions/creditnote/items', name:'creditNoteItems', component:accountBookItems, props: {settings:{transactionTypeId:transaction.creditNote.id}}},
    // { path: '/transactions/creditnote/items/new', name:'newCreditNote', component:accountBookForm, props: {settings:{transactionTypeId:transaction.creditNote.id}}},
    // { path: '/transactions/creditnote/items/:tagId', name:'creditNoteDisplay', component:accountBookDisplay, props: {settings:{transactionTypeId:transaction.creditNote.id}}},
    // { path: '/transactions/creditnote/items/:tagId/edit', name:'creditNoteEdit', component:accountBookForm, props: {settings:{transactionTypeId:transaction.creditNote.id}}},

    // //Debit Note
    // { path: '/transactions/debitnote/items', name:'debitNoteItems', component:accountBookItems, props: {settings:{transactionTypeId:transaction.debitNote.id}}},
    // { path: '/transactions/debitnote/items/new', name:'newDebitNote', component:accountBookForm, props: {settings:{transactionTypeId:transaction.debitNote.id}}},
    // { path: '/transactions/debitnote/items/:tagId', name:'debitNoteDisplay', component:accountBookDisplay, props: {settings:{transactionTypeId:transaction.debitNote.id}}},
    // { path: '/transactions/debitnote/items/:tagId/edit', name:'debitNoteEdit', component:accountBookForm, props: {settings:{transactionTypeId:transaction.debitNote.id}}},

    //Opening Stock
    { path: '/transactions/inventory/openingstock/items', name:'stockItems', component:openingStockItems, props: {settings:{transactionTypeId:transaction.openingStock.id}}},
    { path: '/transactions/inventory/openingstock/items/new', name:'newStock', component:openingStockForm, props: {settings:{transactionTypeId:transaction.openingStock.id}}},
    { path: '/transactions/inventory/openingstock/items/:tagId', name:'stockDisplay', component:openingStockDisplay, props: {settings:{transactionTypeId:transaction.openingStock.id}}},
    { path: '/transactions/inventory/openingstock/items/:tagId/edit', name:'stockEdit', component:openingStockForm, props: {settings:{transactionTypeId:transaction.openingStock.id}}},

    //Stock Journal
    { path: '/transactions/inventory/stockjournal/items', name:'stockJournalItems', component:stockJournalItems, props: {settings:{transactionTypeId:transaction.stockJournal.id}}},
    { path: '/transactions/inventory/stockjournal/items/new', name:'newstockJournal', component:stockJournalForm, props: {settings:{transactionTypeId:transaction.stockJournal.id}}},
    { path: '/transactions/inventory/stockjournal/items/:tagId', name:'stockJournalDisplay', component:stockJournalDisplay, props: {settings:{transactionTypeId:transaction.stockJournal.id}}},
    { path: '/transactions/inventory/stockjournal/items/:tagId/edit', name:'stockJournalEdit', component:stockJournalForm, props: {settings:{transactionTypeId:transaction.stockJournal.id}}},

    //Stock Adjustment
    { path: '/transactions/inventory/stockadjustment/items/new', name:'newStockAdjustment', component:stockAdjustmentForm, props: {settings:{transactionTypeId:transaction.stockAdjustment.id}}},
    { path: '/transactions/inventory/stockadjustment/items/:tagId', name:'stockAdjustmentDisplay', component:stockAdjustmentDisplay, props: {settings:{transactionTypeId:transaction.stockAdjustment.id}}},
    { path: '/transactions/inventory/stockadjustment/items/:tagId/edit', name:'stockAdjustmentEdit', component:stockAdjustmentForm, props: {settings:{transactionTypeId:transaction.stockAdjustment.id}}},

    //Stock Transfer
    { path: '/transactions/inventory/stocktransfer/items', name:'stockTransferItems', component:stockTransferItems, props: {settings:{transactionTypeId:transaction.stockTransfer.id}}},
    { path: '/transactions/inventory/stocktransfer/items/new', name:'newStockTransfer', component:stockTransferForm, props: {settings:{transactionTypeId:transaction.stockTransfer.id}}},
    { path: '/transactions/inventory/stocktransfer/items/:tagId', name:'stockTransferDisplay', component:stockTransferDisplay, props: {settings:{transactionTypeId:transaction.stockTransfer.id}}},
    { path: '/transactions/inventory/stocktransfer/items/:tagId/edit', name:'stockTransferEdit', component:stockTransferForm, props: {settings:{transactionTypeId:transaction.stockTransfer.id}}},

    //Bom Production
    { path: '/transactions/inventory/billofmaterials/items', name:'bomProductionItems', component:bomProductionItems, props: {settings:{transactionTypeId:transaction.bomProduction.id}}},
    { path: '/transactions/inventory/billofmaterials/items/new', name:'newBomProduction', component:bomProductionForm, props: {settings:{transactionTypeId:transaction.bomProduction.id}}},
    { path: '/transactions/inventory/billofmaterials/items/:tagId', name:'bomProductionDisplay', component:bomProductionDisplay, props: {settings:{transactionTypeId:transaction.bomProduction.id}}},
    { path: '/transactions/inventory/billofmaterials/items/:tagId/edit', name:'bomProductionEdit', component:bomProductionForm, props: {settings:{transactionTypeId:transaction.bomProduction.id}}},

    //Opening Ledger
    { path: '/transactions/inventory/openingledger/items', name:'openingLedgerItems', component:openingLedgerItems, props: {settings:{transactionTypeId:transaction.openingLedger.id}}},
    { path: '/transactions/inventory/openingledger/items/new', name:'newOpeningLedger', component:openingLedgerForm, props: {settings:{transactionTypeId:transaction.openingLedger.id}}},
    { path: '/transactions/inventory/openingledger/items/:tagId', name:'openingLedgerDisplay', component:openingLedgerDisplay, props: {settings:{transactionTypeId:transaction.openingLedger.id}}},
    { path: '/transactions/inventory/openingledger/items/:tagId/edit', name:'openingLedgerEdit', component:openingLedgerForm, props: {settings:{transactionTypeId:transaction.openingLedger.id}}},

    //purchase order
    { path: '/transactions/purchase/purchaseorder/items', name:'purchaseOrderItems', component:purchaseItems, props: {settings:{transactionTypeId:transaction.purchaseOrder.id}}},
    { path: '/transactions/purchase/purchaseorder/items/new', name:'newPurchaseOrder', component:purchaseForm, props: {settings:{transactionTypeId:transaction.purchaseOrder.id}}},
    { path: '/transactions/purchase/purchaseorder/items/:tagId', name:'purchaseOrderDisplay', component:purchaseDisplay, props: {settings:{transactionTypeId:transaction.purchaseOrder.id}}},
    { path: '/transactions/purchase/purchaseorder/items/:tagId/edit', name:'purchaseOrderEdit', component:purchaseForm, props: {settings:{transactionTypeId:transaction.purchaseOrder.id}}},

    //purchase challan
    { path: '/transactions/purchase/purchasechallan/items', name:'purchaseChallanItems', component:purchaseItems, props: {settings:{transactionTypeId:transaction.purchaseChallan.id}}},
    { path: '/transactions/purchase/purchasechallan/items/new', name:'newPurchaseChallan', component:purchaseForm, props: {settings:{transactionTypeId:transaction.purchaseChallan.id}}},
    { path: '/transactions/purchase/purchasechallan/items/:tagId', name:'purchaseChallanDisplay', component:purchaseDisplay, props: {settings:{transactionTypeId:transaction.purchaseChallan.id}}},
    { path: '/transactions/purchase/purchasechallan/items/:tagId/edit', name:'purchaseChallanEdit', component:purchaseForm, props: {settings:{transactionTypeId:transaction.purchaseChallan.id}}},

    //purchase invoice
    { path: '/transactions/purchase/purchaseinvoice/items', name:'purchaseInvoiceItems', component:purchaseItems, props: {settings:{transactionTypeId:transaction.purchaseInvoice.id}}},
    { path: '/transactions/purchase/purchaseinvoice/items/new', name:'newPurchaseInvoice', component:purchaseForm, props: {settings:{transactionTypeId:transaction.purchaseInvoice.id}}},
    { path: '/transactions/purchase/purchaseinvoice/items/:tagId', name:'purchaseInvoiceDisplay', component:purchaseDisplay, props: {settings:{transactionTypeId:transaction.purchaseInvoice.id}}},
    { path: '/transactions/purchase/purchaseinvoice/items/:tagId/edit', name:'purchaseInvoiceEdit', component:purchaseForm, props: {settings:{transactionTypeId:transaction.purchaseInvoice.id}}},

    //purchase return
    { path: '/transactions/purchase/purchasereturn/items', name:'purchaseReturnItems', component:purchaseItems, props: {settings:{transactionTypeId:transaction.purchaseReturn.id}}},
    { path: '/transactions/purchase/purchasereturn/items/new', name:'newPurchaseReturn', component:purchaseForm, props: {settings:{transactionTypeId:transaction.purchaseReturn.id}}},
    { path: '/transactions/purchase/purchasereturn/items/:tagId', name:'purchaseReturnDisplay', component:purchaseDisplay, props: {settings:{transactionTypeId:transaction.purchaseReturn.id}}},
    { path: '/transactions/purchase/purchasereturn/items/:tagId/edit', name:'purchaseReturnEdit', component:purchaseForm, props: {settings:{transactionTypeId:transaction.purchaseReturn.id}}},

    //Expense
    { path: '/transactions/purchase/expense/items', name:'expenseItems', component:expenseItems, props: {settings:{transactionTypeId:transaction.expense.id}}},
    { path: '/transactions/purchase/expense/items/new', name:'newExpense', component:expenseForm, props: {settings:{transactionTypeId:transaction.expense.id}}},
    { path: '/transactions/purchase/expense/items/:tagId', name:'expenseDisplay', component:expenseDisplay, props: {settings:{transactionTypeId:transaction.expense.id}}},
    { path: '/transactions/purchase/expense/items/:tagId/edit', name:'expenseEdit', component:expenseForm, props: {settings:{transactionTypeId:transaction.expense.id}}},

    //purchase invoice
    { path: '/transactions/purchase/debitnote/items', name:'debitNoteItems', component:purchaseItems, props: {settings:{transactionTypeId:transaction.debitNote.id}}},
    { path: '/transactions/purchase/debitnote/items/new', name:'newDebitNoteInvoice', component:purchaseForm, props: {settings:{transactionTypeId:transaction.debitNote.id}}},
    { path: '/transactions/purchase/debitnote/items/:tagId', name:'debitNoteDisplay', component:purchaseDisplay, props: {settings:{transactionTypeId:transaction.debitNote.id}}},
    { path: '/transactions/purchase/debitnote/items/:tagId/edit', name:'debitNoteEdit', component:purchaseForm, props: {settings:{transactionTypeId:transaction.debitNote.id}}},

    //sales order
    { path: '/transactions/sales/order/items', name:'salesOrderItems', component:salesItems, props: {settings:{transactionTypeId:transaction.order.id}}},
    { path: '/transactions/sales/order/items/new', name:'newSalesOrder', component:salesForm, props: {settings:{transactionTypeId:transaction.order.id}}},
    { path: '/transactions/sales/order/items/:tagId', name:'salesOrderDisplay', component:salesDisplay, props: {settings:{transactionTypeId:transaction.order.id}}},
    { path: '/transactions/sales/order/items/:tagId/edit', name:'salesOrderEdit', component:salesForm, props: {settings:{transactionTypeId:transaction.order.id}}},

    //delivery challan
    { path: '/transactions/sales/deliverychallan/items', name:'salesChallanItems', component:salesItems, props: {settings:{transactionTypeId:transaction.deliveryChallan.id}}},
    { path: '/transactions/sales/deliverychallan/items/new', name:'newSalesChallan', component:salesForm, props: {settings:{transactionTypeId:transaction.deliveryChallan.id}}},
    { path: '/transactions/sales/deliverychallan/items/:tagId', name:'salesChallanDisplay', component:salesDisplay, props: {settings:{transactionTypeId:transaction.deliveryChallan.id}}},
    { path: '/transactions/sales/deliverychallan/items/:tagId/edit', name:'salesChallanEdit', component:salesForm, props: {settings:{transactionTypeId:transaction.deliveryChallan.id}}},

    //sale invoice
    { path: '/transactions/sales/saleinvoice/items', name:'saleInvoiceItems', component:salesItems, props: {settings:{transactionTypeId:transaction.salesInvoice.id}}},
    { path: '/transactions/sales/saleinvoice/items/new', name:'newSaleInvoice', component:salesForm, props: {settings:{transactionTypeId:transaction.salesInvoice.id}}},
    { path: '/transactions/sales/saleinvoice/items/:tagId', name:'saleInvoiceDisplay', component:salesDisplay, props: {settings:{transactionTypeId:transaction.salesInvoice.id}}},
    { path: '/transactions/sales/saleinvoice/items/:tagId/edit', name:'saleInvoiceEdit', component:salesForm, props: {settings:{transactionTypeId:transaction.salesInvoice.id}}},

    //sales return
    { path: '/transactions/sales/salereturn/items', name:'saleReturnItems', component:salesItems, props: {settings:{transactionTypeId:transaction.salesReturn.id}}},
    { path: '/transactions/sales/salereturn/items/new', name:'newSaleReturn', component:salesForm, props: {settings:{transactionTypeId:transaction.salesReturn.id}}},
    { path: '/transactions/sales/salereturn/items/:tagId', name:'saleReturnDisplay', component:salesDisplay, props: {settings:{transactionTypeId:transaction.salesReturn.id}}},
    { path: '/transactions/sales/salereturn/items/:tagId/edit', name:'saleReturnEdit', component:salesForm, props: {settings:{transactionTypeId:transaction.salesReturn.id}}},

    //estimate
    { path: '/transactions/sales/estimate/items', name:'estimateItems', component:salesItems, props: {settings:{transactionTypeId:transaction.estimate.id}}},
    { path: '/transactions/sales/estimate/items/new', name:'newEstimate', component:salesForm, props: {settings:{transactionTypeId:transaction.estimate.id}}},
    { path: '/transactions/sales/estimate/items/:tagId', name:'estimateDisplay', component:salesDisplay, props: {settings:{transactionTypeId:transaction.estimate.id}}},
    { path: '/transactions/sales/estimate/items/:tagId/edit', name:'estimateEdit', component:salesForm, props: {settings:{transactionTypeId:transaction.estimate.id}}},

    //estimate
    { path: '/transactions/sales/creditnote/items', name:'creditNoteItems', component:salesItems, props: {settings:{transactionTypeId:transaction.creditNote.id}}},
    { path: '/transactions/sales/creditnote/items/new', name:'newCreditNote', component:salesForm, props: {settings:{transactionTypeId:transaction.creditNote.id}}},
    { path: '/transactions/sales/creditnote/items/:tagId', name:'creditNoteDisplay', component:salesDisplay, props: {settings:{transactionTypeId:transaction.creditNote.id}}},
    { path: '/transactions/sales/creditnote/items/:tagId/edit', name:'creditNoteEdit', component:salesForm, props: {settings:{transactionTypeId:transaction.creditNote.id}}},

    // Credit Debit Note
    { path: '/transactions/creditnote/items/new', name:'newCreditNote', component:creditDebitNote, props: {settings:{transactionTypeId:transaction.creditNote.id}}},
    
    //Number Series
    { path: '/numberseries/items', name:'numberSeriesItems', component:numberSeriesItems},
    { path: '/numberseries/items/new', name:'newNumberSeries', component:numberSeriesForm},
    { path: '/numberseries/items/:tagId/edit', name:'numberSeriesEdit', component:numberSeriesForm},

    //Print Templates
    { path: '/printtemplate/items', name:'printTemplateItems', component:printTemplateItems},
    { path: '/printtemplate/items/new', name:'newPrintTemplate', component:printTemplateForm},
    { path: '/printtemplate/items/:tagId/edit', name:'printTemplateEdit', component:printTemplateForm},

    //Print Fields
    { path: '/printfield/items', name:'printFieldItems', component:printFieldItems},
    { path: '/printfield/items/new', name:'newPrintField', component:printFieldForm},
    { path: '/printfield/items/:tagId/edit', name:'printFieldEdit', component:printFieldForm},

    //Price List
    // { path: '/pricelist/items', name:'priceListItems', component:priceListItems},
    // { path: '/pricelist/items/new', name:'newPriceList', component:priceListForm},
    // { path: '/pricelist/items/:tagId', name:'priceListDisplay', component:priceListDisplay},
    // { path: '/pricelist/items/:tagId/edit', name:'priceListEdit', component:priceListForm},

    // //User Settings
    // { path: '/settings/usersettings/items', name:'userItems', component:userSettings},

    // //Users
    // { path: '/settings/usersettings/user/items', name:'userItems', component:userItems},
    // { path: '/settings/usersettings/user/items/new', name:'newUser', component:userForm},
    // { path: '/settings/usersettings/user/items/:tagId/edit', name:'userEdit', component:userForm},

    // //Users
    // { path: '/settings/usersettings/designation/items', name:'designationItems', component:designationItems},
    // { path: '/settings/usersettings/designation/items/new', name:'newDesignation', component:designationForm},
    // { path: '/settings/usersettings/designation/items/:tagId/edit', name:'designationEdit', component:designationForm},

    // //Users
    // { path: '/settings/usersettings/permissiongroup/items', name:'permissionGroupItems', component:permissionGroupItems},
    // { path: '/settings/usersettings/permissiongroup/items/new', name:'newPermissionGroup', component:permissionGroupForm},
    // { path: '/settings/usersettings/permissiongroup/items/:tagId/edit', name:'permissionGroupEdit', component:permissionGroupForm},

    //login
    // { path: '/registration/business/login', name:'loginForm', component:loginForm},
    // { path: '/registration/business/activate', name:'activateBusiness', component:activateBusiness, props:true},
    // { path: '/registration/business/register', name:'signupForm', component:signupForm},
    // { path: '/registration/business/new', name:'newBusiness', component:newBusiness},
    { path: '/registration/business/:businessid/details', name:'businessDetails', component:businessDetails},
    { path: '/registration/business/:businessid/edit', name:'updateBusiness', component:updateBusiness},
    // { path: '/registration/business/register', name:'updateBusiness', component:updateBusiness},
    { path: '/registration/business/verifycode', name:'otpVerification', component:otpVerification, props:true},
    { path: '/registration/business/setupdrive', name:'setupDrive', component:setupDrive},
    // { path: '/registration/business/business_selection', name:'selectBusiness', component:selectBusiness},
    // { path: '/registration/business/restore_data', name:'restoreData', component:restoreData},
    { path: '/registration/business/change_phone_number', name:'changePhoneNumber', component:changePhoneNumber, props:true},

    { path: '/registration/business/usertype', name:'userType', component:userType},

    //ledger report temp
    { path: '/ledgerreport', name:'ledgerReport', component:ledgerReport},

    // new reports
    // { path: '/reports/:businessid', name:'reportList', component:reportList},
    { path: '/reports/:businessid/:reportid', name:'reportContainer', component:reportContainer},

    { path: '/barcode/scanner', name:'barcodeScanner', component:barcodeScanner},
    { path: '/barcode/generator', name:'barcodeGenerator', component:barcodeGenerator},
    { path: '/barcode/config', name:'barcodeLabelConfig', component:barcodeLabelConfig},
    { path: '/barcode/designer', name:'barcodeDesigner', component:barcodeDesigner},

    { path: '/barcode/items', name:'barcodeItems', component:barcodeLabelTemplates},

    { path: '/settings/language', name:'languageSelection', component:languageSelection},
    // //Field Forms
    // { path: '/FieldsGroups/Fields/New', component:groupfieldform},

    // { path: '/FieldsGroups/Fields/Section/:Type/New', component:datafie  ldform},

    // { path: '/masters/activitylist', component:masteractivitylist},

    // { path: '/ios/items_ios', component:items_ios},

    // { path: '/', component: test, name:"base"},


  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
        // return savedPosition
        setTimeout(function () {
            window.scrollTo(savedPosition.x, savedPosition.y);
        },300);
    } else {
        return { x: 0, y: 0 }
    }
  },
  // scrollBehavior (to, from, savedPosition) {
  //   return { x: 0, y: 0 }
  // },
  mode: 'history'
})


// WEBPACK FOOTER //
// ./src/router/index.js